import React from 'react';
import './Preloading.css';

const Preloading = ({ className }: { className?: string }) => {
  return (
    <div
      className={
        'preloading-container fixed left-0 top-0 right-0 bottom-0 bg-[#16143e] flex justify-center flex-col' +
        (className !== undefined ? ' ' + className : '')
      }
    >
      <div className="lds-grid self-center inline-block relative w-[80px] h-[80px]">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="preloading-text text-center text-white pt-1 leading-7 mt-4 max-md:leading-6 text-[1rem]">
        <div className="preloading-header font-bold leading-10 hidden max-lg:mt-6 max-md:leading-8 text-[1.125rem]"></div>
        <span className="preloading-body">Loading</span>
      </div>
    </div>
  );
};

export default Preloading;
